import React from 'react';

const FAQS = [
  {
    q: 'Does Goldie detect falls?',
    a: "Goldie isn't a fall detector, and we're deliberate about that. In-shower fall detection with water running is unreliable industry-wide — the spray itself defeats the sensor. Goldie instead knows your normal shower and responds when it deviates: a voice check-in, then safely stopping the water, then notifying your care contacts if there's no response.",
  },
  {
    q: 'Do you have an installation team?',
    a: 'Yes — we have a team that comes on-site to install every unit, so there’s nothing for you or your staff to set up yourselves.',
  },
];

function Faq() {
  return (
    <section className="pt-5 pb-16 md:pb-24" id="faq">
      <div className="max-w-[1180px] mx-auto px-6 md:px-8">
        <div className="text-center max-w-[600px] mx-auto mb-10">
          <h2 className="font-display text-[1.9rem] md:text-[2.2rem] font-bold text-navy-deep">
            Frequently Asked <span className="text-sky">Questions</span>
          </h2>
        </div>

        <div className="max-w-[760px] mx-auto flex flex-col gap-5">
          {FAQS.map((item) => (
            <div key={item.q} className="bg-cream shadow-nu-out rounded-nu p-6 md:p-8">
              <h3 className="font-display text-[1.15rem] font-semibold text-navy-deep mb-2.5">
                {item.q}
              </h3>
              <p className="text-[1rem] text-navy leading-[1.65] m-0">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
